export const GET_REMITTANCE_REQUEST = "GET_PRODUCT_ACCOUNT_REQUEST";
export const GET_REMITTANCE_SUCCESS = "GET_PRODUCT_ACCOUNT_SUCCESS";
export const GET_REMITTANCE_FAILURE = "GET_PRODUCT_ACCOUNT_FAILURE";

export const GET_REMITTANCE_SETTINGS_VALUES_REQUEST =
  "GET_REMITTANCE_SETTINGS_VALUES_REQUEST";
export const GET_REMITTANCE_SETTINGS_VALUES_SUCCESS =
  "GET_REMITTANCE_SETTINGS_VALUES_SUCCESS";
export const GET_REMITTANCE_SETTINGS_VALUES_FAILURE =
  "GET_REMITTANCE_SETTINGS_VALUES_FAILURE";

export const VIEW_PASSWORD_POLICY_REQUEST = "VIEW_PASSWORD_POLICY_REQUEST";
export const VIEW_PASSWORD_POLICY_SUCCESS = "VIEW_PASSWORD_POLICY_SUCCESS";
export const VIEW_PASSWORD_POLICY_FAILURE = "VIEW_PASSWORD_POLICY_FAILURE";

export const GET_PAYMENT_METHOD_REQUEST = "GET_PAYMENT_METHOD_REQUEST";
export const GET_PAYMENT_METHOD_SUCCESS = "GET_PAYMENT_METHOD_SUCCESS";
export const GET_PAYMENT_METHOD_FAILURE = "GET_PAYMENT_METHOD_FAILURE";

export const GET_FIXED_AMOUNT_FEE_REQUEST = "GET_FIXED_AMOUNT_FEE_REQUEST";
export const GET_FIXED_AMOUNT_FEE_SUCCESS = "GET_FIXED_AMOUNT_FEE_SUCCESS";
export const GET_FIXED_AMOUNT_FEE_FAILURE = "GET_FIXED_AMOUNT_FEE_FAILURE";
